import { useEffect, useState, type ReactNode } from "react";

const STAGE_WIDTH = 1920;
const STAGE_HEIGHT = 1080;

const getScale = () => Math.min(
  1,
  window.innerWidth / STAGE_WIDTH,
  window.innerHeight / STAGE_HEIGHT,
);

interface Props {
  children: ReactNode;
}

export function ScaledStage({ children }: Props) {
  const [scale, setScale] = useState(getScale);

  useEffect(() => {
    const updateScale = () => setScale(getScale());
    window.addEventListener("resize", updateScale);
    return () => window.removeEventListener("resize", updateScale);
  }, []);

  return (
    <div className="stage-viewport">
      <div className="scaled-stage" style={{ transform: `scale(${scale})` }}>
        {children}
      </div>
    </div>
  );
}
